var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgContactIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 11H11c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V13c0-1.103-.897-2-2-2zm1 12c0 .55-.45 1-1 1H11c-.55 0-1-.45-1-1V13c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v10zm-2.25-4h-3.5a.25.25 0 0 0-.25.25v.5c0 .137.113.25.25.25h3.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm0-2h-3.5a.25.25 0 0 0-.25.25v.5c0 .137.113.25.25.25h3.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm0-2h-3.5a.25.25 0 0 0-.25.25v.5c0 .137.113.25.25.25h3.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25zm-8.25 4a2.5 2.5 0 1 0 .001-4.999A2.5 2.5 0 0 0 15.5 19zm0-4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm1.462 4.5c-.609 0-.762.219-1.462.219s-.853-.219-1.463-.219c-.662 0-1.306.294-1.68.856A2.092 2.092 0 0 0 12 21.528v.722c0 .137.113.25.25.25h.5a.25.25 0 0 0 .25-.25v-.722c0-.219.066-.431.188-.612.175-.26.493-.413.853-.413.387 0 .65.219 1.462.219.81 0 1.072-.219 1.463-.219.359 0 .678.156.853.413.122.18.187.393.187.612v.722c0 .137.113.25.25.25h.5a.25.25 0 0 0 .25-.25v-.722c0-.434-.131-.837-.356-1.172-.384-.562-1.028-.856-1.688-.856z",
    fill: "#AEAEBD",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContactIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contactIcon.71cfc3c3.svg";
export { ForwardRef as ReactComponent };